import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import HamburgerMenu from 'src/components/UI/HamburgerMenu/HamburgerMenu'
import MenuModal from 'src/components/Modals/MenuModal/MenuModal'
import MainNav from 'src/containers/TopStripe/MainNav/MainNav'
import Welcome from 'src/containers/TopStripe/Welcome/Welcome'
import Logo from 'src/components/UI/Logo/Logo'
import topStripeClasses from './TopStripe.module.scss'
import { getFirstName } from 'training-lane-booking-shared/utilities/functions'

const TopStripe = ({
    displayName,
    location,
    menuLinks,
    landingPage,
    pageTitle,
    showHeader,
    isSmall,
    isXSmall
}) => {
    const firstName = getFirstName(displayName)

    const logoProps = { landingPage, isXSmall, showHeader }

    const middleText = landingPage ? <Welcome firstName={firstName} /> : pageTitle

    return (
        <section className={classNames(
            showHeader
                ? topStripeClasses.topStripeWrapper
                : topStripeClasses.topStripeWrapperLandingPage,
            {
                [topStripeClasses.topStripeMe]: isXSmall && (location.pathname.indexOf('/me') !== -1 || landingPage)
            }
        )}>
                <div className={classNames(topStripeClasses.fullWidth, 'grid-wrapper')}>
                    <MenuModal location={location} />
                    {(isXSmall || landingPage) ? (
                        <>
                            <Logo {...logoProps} />
                            <div
                                className={classNames(
                                    topStripeClasses.headerMiddleText,
                                    'col-8',
                                    'align-center',
                                    {
                                        [topStripeClasses.headerMiddleTextLandingPage]: landingPage,
                                        [topStripeClasses.headerMiddleTextNoHeader]: !landingPage && !showHeader
                                    }
                                )}>
                                {middleText}
                            </div>
                        </>
                    ) : null}
                    {isSmall ?
                        (
                            <div
                                className={classNames(topStripeClasses.hamburger, {
                                    ['col-2']: isXSmall
                                })}>
                                <HamburgerMenu />
                            </div>
                        ) : (
                            <div className={topStripeClasses.topStripe}>
                                <MainNav
                                    inline
                                    menuLinks={menuLinks}
                                    location={location}
                                    activeClass={topStripeClasses.topStripeActiveMenu}
                                />
                            </div>
                        )}
                </div>
        </section>
    )
}

const mapState = state => ({
    displayName: state.firebase.profile.displayName ?? ''
})

export default connect(mapState)(TopStripe)
